const axios = require('axios');


const forgotPasswordReset = async (PostedValues, mtoken, emref, tokenref) => {
    const apiUrl = window.spconfig?.config.apiUrl;
    const urlLink = apiUrl + "/growapi/resetpwd";
    const data = {
        pass: PostedValues,
        mtoken: mtoken,
        emref: emref,
        tokenref: tokenref
    };
    return await axios.post(urlLink, JSON.stringify(data), {
        headers: { "Content-Type": "application/json" },
    })
        .then((response) => {
            return response;
        },
            (error) => {
                return error;
            })
}
export default forgotPasswordReset;
